import React from 'react'
import MainLayout from '../components/MainLayout'

const Report1 = () => {
  return (
     <MainLayout pageName={"4"}>
 <div>Report1</div>
     </MainLayout>
   
  )
}

export default Report1